import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import router from './router'
import langPt from 'quasar/lang/pt-BR'
import iconSet from 'quasar/icon-set/fontawesome-v6'
import '@quasar/extras/fontawesome-v6/fontawesome-v6.css'
// import Authentication from '@/services/authentication';
import Vuex from 'vuex';

const app = createApp(App)

app.use(router)
app.use(Quasar, {
    ...quasarUserOptions,
    lang: langPt,
    iconSet: iconSet
})
app.use(Vuex)

// Authentication.initialize().then(() => {
app.mount('#app')
// })